<template>
<div>
    <div v-if="isLoading" class="loader-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    <div class="container-fluid">
        <div class="llp-container-section heightcontainer">
            <top-header id="height2"></top-header>
            <main-menu id="height3"></main-menu>
            <div class="menu-margin-top">
                <div class="row px-3 ml-0 justify-content-between">
                    <div class="col-sm-12 mt-3 mb-4">
                        <ul class="navLinks">
                            <li>
                                <router-link :class="{ active: isActiveRoute('/mergeDealer') }" class="linkItem" to="/mergeDealer">Duplicate Dealers</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active: isActiveRoute('/mergedDealersList') }" class="linkItem" to="/mergedDealersList">Merged Dealers</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active: isActiveRoute('/dealerActivityLog') }" class="linkItem" to="/dealerActivityLog">Activity Log</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-8 col-sm-12">
                        <h3>Activity Log</h3>
                    </div>
                    <div class="col-lg-3 col-sm-12 activitySearch">
                        <input @input="handleClearSearch()" type="text" placeholder="Search" v-model="activitySearch">
                    </div>
                    <div class="col-lg-1 activityBtn">
                      <button @click="searchDebounce()" :disabled='!activitySearch.trim()'>Search</button>
                    </div>
                    <div class="col-12 col-md-12">
                      <p class="clearText"><a type="button" 
                      @click="clearSearch()"
                      >Clear Search</a></p>
                  </div>
                </div>
                <div class="row tableContainer pb-4 px-3 ml-0">
                  <div class="col-12">
                    <table class="table table-responsive-sm mt-4 customerTable">
                      <thead class="tableHeading">
                        <tr>
                          <th style="width:25%">Time</th>
                          <th style="width:25%">Author</th>
                          <th style="width:20%">IP Address</th>
                          <th style="width:15%">No. of User Merged</th>
                          <th style="width:10%">Status</th>
                        </tr>
                      </thead>
                      <template>
                      <tbody v-if="activityList.length>0">
                        <tr v-for="activity of activityList" :key="activity.id">
                          <td class="tableCustomerId align-middle">{{activity.formattedDate}}</td>
                          <td class="tableName align-middle">{{activity.employeeFirstName + ' ' + activity.employeeLastName}}</td>
                          <td class="tableEmail align-middle">{{activity.ipAddress}}</td>
                          <td class="tableMobile align-middle">{{activity.actionCount}}</td>
                          <td class="tableDate align-middle" :class="activity.actionName === 'Merged' ? 'mergeStatus' : 'unMergeStatus'" >{{activity.actionName}}</td>
                        </tr>
                      </tbody>
                      <tbody v-else class="text-center">
                        {{noResult}}
                      </tbody>
                      </template>
                    </table>
                  </div>
                </div>
            </div>
            <div class="mt-5 mb-5 pb-3">
                    <b-pagination align="center" v-if="rows>perPage && activityList.length>0"
                     v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-number
                    last-number
                    @input="pagination"
                    class="customPagination"
                    ></b-pagination>
            </div>
            <bottom-footer></bottom-footer>
        </div>
    </div>
</div>
</template>
<script>
import TopHeader from "@/components/TopHeader.vue";
import MainMenu from "@/components/Menu.vue";
import BottomFooter from "@/components/BottomFooter.vue";
import httpcommon from "../js/http-common.js";
import moment from 'moment';

export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter,
  },
  name: "dealerActivityLog",

  data() {
  return {
    activityList: [],
    noResult: '',
    isLoading: false,
    rows: 0,
    currentPage: 1,
    perPage: 10,
    activitySearch: '',
    firstName: '',
    lastName: '',
    isSearch: false
  }
  },
  methods: {
    getActivityLog () {
        this.isLoading = true
        this.noResult = ''
        this.isSearch = false
        this.activityList = []
        httpcommon.get(`/managesource/getDealerMerge/acivityList?page=${this.currentPage-1}&size=${this.perPage}`).then(response=>{
            this.isLoading = false
            if(response.data.content.length>0) {
                this.activityList = response.data.content
                this.rows = response.data.totalElements
                this.activityList.forEach(activity=>{
                    activity.formattedDate = moment(activity.actionDate).format("Do MMM, YYYY [at] h:mma");
                    if(activity.actionName=='unmerged') {
                        activity.actionName = 'Un-Merged'
                    } else {
                        activity.actionName = 'Merged'
                    }
                })
            } else {
                this.noResult = 'No Result Found'
            }
        }).catch(error=>{
            this.isLoading = false
            console.log(error)
        })
    },
    pagination () {
      if(!this.activitySearch) {
        this.getActivityLog()
      } else {
        this.searchActivity()
      }
    },
    clearSearch () {
      this.activitySearch = ''
      this.handleClearSearch()
    },
    searchDebounce () {
      this.currentPage = 1
      this.searchActivity()
    },
    searchActivity () {
      const names = this.activitySearch.trim().split(' ');
      if (names.length > 1) {
        this.firstName = names[0]; // The first word is the first name
        this.lastName = names.slice(1).join(' '); // The rest is the last name
      } else {
        this.firstName = names[0]; // If only one word is entered, it's considered the first name
        this.lastName = '';
      }
      let searchParams = new URLSearchParams()
      if(this.firstName) {
        searchParams.append('firstName',this.firstName)
      }
      if(this.lastName) {
        searchParams.append('lastName',this.lastName)
      }
     this.isLoading = true
     this.noResult = ''
     this.isSearch = false
     this.activityList = []
        httpcommon.get(`/managesource/getDealerMerge/acivityList?${searchParams.toString()}&page=${this.currentPage-1}&size=${this.perPage}`).then(response=>{
            this.isLoading = false
            this.isSearch = true
            if(response.data.content.length>0) {
                this.activityList = response.data.content
                this.rows = response.data.totalElements
                this.activityList.forEach(activity=>{
                    activity.formattedDate = moment(activity.actionDate).format("Do MMM, YYYY [at] h:mma");
                    if(activity.actionName=='unmerged') {
                        activity.actionName = 'Un-Merged'
                    } else {
                        activity.actionName = 'Merged'
                    }
                })
            } else {
                this.noResult = 'No Result Found'
            }
        }).catch(error=>{
            this.isLoading = false
            console.log(error)
        })
    },
    handleClearSearch () {
      if (this.activitySearch==='' && this.isSearch) {
        this.activityList = []
        this.currentPage = 1
        this.firstName = ''
        this.lastName = ''
        this.getActivityLog()
      }
    },
    isActiveRoute(route) {
      return this.$route.path === route;
    },
    retrieveData: function () {
      httpcommon
        .get("/userrole/")
        .then((response) => {
          this.userroles = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.errorslist.push(e);
        });
      httpcommon
        .get("/staticdata/status/")
        .then((response) => {
          this.status = response.data;
        })
        .catch((e) => {
          this.errorslist.push(e);
        });
    },
    myFunction() {
      var elmnt = document.getElementById("height2");
      var elmnt1 = document.getElementById("height3");
      var txt = elmnt.offsetHeight;
      var width = elmnt.offsetWidth;
      var txt1 = elmnt1.offsetHeight;
      var ht = txt + txt1;
      $("#employee").css("margin-top", txt + txt1 + 3);
    },
    menuheight () {
      var elmnt = document.getElementById("height2");
      var txt = elmnt.offsetHeight;
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.myFunction()
    this.menuheight()
    this.getActivityLog()
  },
}
</script>
<style scoped>
.customerTable {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
  table-layout: auto;
  width: 100%;
}
.customerTable thead tr {
  color: #9B9B9B;
  font: 600 14px 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
}
.customerTable thead tr th {
    border-top: none;
    white-space: nowrap;
}
.customerTable tbody tr td {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
}
tbody tr {
  border-bottom: 1px solid #dbdbdb;
}
.mergeStatus {
    color: #00AA00 !important;
}
.unMergeStatus {
    color: #F22A0E !important;
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.customPagination ::v-deep .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none ;
  height: 30px;
  width: 30px;
  margin: 0;
  padding: 10px;
  font-size: 20px;
  color: #9B9B9B;
}
.customPagination ::v-deep .active .page-link {
  background-color: #005DF1;
  border-radius: 8px;
  color: #FFFFFF;
}
.pagination.customPagination ::v-deep .page-item:first-child .page-link,
.pagination.customPagination ::v-deep .page-item:last-child .page-link {
  font-size: 40px !important; /* Adjust the font size as needed */
  padding: 0 20px 10px 20px;
}
.navLinks {
    list-style: none;
    display: flex;
    padding-left: 0;
    justify-content: center;
}
.navLinks li {
    padding: 10px 35px 10px 0px;
}
.linkItem {
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
font-size: 18px;
font-weight: 600;
color: #8C8C8C;
Padding:10px 30px 10px 30px;
border-radius: 8px;
}
.linkItem:hover {
    color: #FFFFFF;
    background-color: #1E90FF;
}
.navLinks .active {
color: #FFFFFF !important;
background-color: #1E90FF;
}
.activitySearch input {
  font: 400;
  font-size: 16px;
  color: #1C1B1F;
  border: 1px solid #E4ECF4;
  border-radius: 8px;
  padding: 10px;
  height: 44px;
  width: 100%;
}
.activityBtn button {
  border-radius: 8px;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 18px;
  background-color: #1E90FF;
  padding: 10px;
  height: 44px;
  width: 160px;
  border: none;
  width: 100%;
}
.clearText {
  text-align: end;
  /* padding-right: 25px; */
  margin: 0;
}
.clearText a {
  cursor: pointer;
  color: #91a7bd ;
  font-weight: 400;
  font-size: 13px;
  text-decoration: underline;
}
.clearText a:hover {
  
  color: #1e90ff;
}
</style>